<template>
  <div>
    <header class="md:fixed md:w-full md:z-10 md:top-0 bg-white border-b px-4 shadow">
      <div class="container mx-auto">
        <div class="flex items-baseline justify-between">
          <div class="flex items-baseline">
            <div class="">
              <router-link exact active-class="bg-gray-100" :to="{name: 'home'}" class="block font-brand text-2xl tracking-wider py-3 px-6 font-semibold hover:bg-teal-100">Poulpy Chou</router-link>
            </div>
            <div>
              <div class="hidden lg:block py-4">
                <router-link active-class="lg:bg-gray-100" class="px-2 xl:px-4 py-5 hover:bg-teal-100 hover:text-blue-500" :to="{name: 'illustrations'}">Illustration jeunesse</router-link>
                <router-link active-class="lg:bg-gray-100" class="px-2 xl:px-4 py-5 hover:bg-teal-100 hover:text-blue-500" :to="{name: 'strips'}">BD</router-link>
                <router-link active-class="lg:bg-gray-100" class="px-2 xl:px-4 py-5 hover:bg-teal-100 hover:text-blue-500" :to="{name: 'originals'}">Oeuvres originales</router-link>
                <router-link active-class="lg:bg-gray-100" class="px-2 xl:px-4 py-5 hover:bg-teal-100 hover:text-blue-500" :to="{name: 'about'}">Qui suis-je ?</router-link>
                <a class="px-2 xl:px-4 py-5 hover:bg-teal-100 hover:text-blue-500"
                  href="https://poulpychou.sumup.link"
                  target="_blank"
                  title="Etsy - Poulpy Chou">
                  Boutique
                </a>
              </div>
            </div>
          </div>
          <div class="hidden lg:block py-4">
            <div class="flex items-end">
              <div>
                <a class="lg:ml-4 xl:ml-6" href="https://www.facebook.com/poulpesqueries/" target="_blank" title="Facebook - Poulpy Chou">
                  <!-- facebook -->
                  <svg class="fill-current inline-block h-6 text-gray-500 hover:text-blue-500" viewBox="0 0 20 20">
                    <path d="M11.344,5.71c0-0.73,0.074-1.122,1.199-1.122h1.502V1.871h-2.404c-2.886,0-3.903,1.36-3.903,3.646v1.765h-1.8V10h1.8v8.128h3.601V10h2.403l0.32-2.718h-2.724L11.344,5.71z"></path>
                  </svg>
                </a>
                <!-- tumblr -->
                <a class="lg:ml-4 xl:ml-6" href="http://poulpychou.tumblr.com" target="_blank"  title="Tumblr - Poulpy Chou">
                  <svg class="fill-current inline-block h-6 text-gray-500 hover:text-blue-500" viewBox="0 0 20 20">
                    <path d="M11.039,14.123c-0.231-0.129-0.414-0.303-0.498-0.518C10.53,13.568,10.54,9.17,10.54,9.17h3.253V6.75h-3.25V3.5L8.474,3.512C8.386,4.181,8.225,4.733,7.991,5.167C7.756,5.601,7.445,5.972,7.059,6.281C6.673,6.592,6.208,6.828,5.665,6.994l0.001,2.194L7.293,9.17v4.215c0,0.594,0.067,1.047,0.198,1.359c0.133,0.312,0.37,0.607,0.713,0.887c0.343,0.277,0.757,0.49,1.242,0.639c0.484,0.15,1.008,0.23,1.64,0.23c0.555,0,1.006-0.057,1.484-0.164c0.479-0.104,1.165-0.287,1.756-0.549l0.009-1.996c-0.692,0.428-1.549,0.59-2.247,0.59C11.693,14.381,11.344,14.293,11.039,14.123">
                    </path>
                  </svg>
                </a>
                <!-- instagram -->
                <a class="lg:ml-4 xl:ml-6" href="http://www.instagram.com/poulpychou/" target="_blank" title="Instagram - Poulpy Chou">
                  <svg class="fill-current inline-block h-6 text-gray-500 hover:text-blue-500" viewBox="0 0 20 20">
                    <path d="M14.52,2.469H5.482c-1.664,0-3.013,1.349-3.013,3.013v9.038c0,1.662,1.349,3.012,3.013,3.012h9.038c1.662,0,3.012-1.35,3.012-3.012V5.482C17.531,3.818,16.182,2.469,14.52,2.469 M13.012,4.729h2.26v2.259h-2.26V4.729z M10,6.988c1.664,0,3.012,1.349,3.012,3.012c0,1.664-1.348,3.013-3.012,3.013c-1.664,0-3.012-1.349-3.012-3.013C6.988,8.336,8.336,6.988,10,6.988 M16.025,14.52c0,0.831-0.676,1.506-1.506,1.506H5.482c-0.831,0-1.507-0.675-1.507-1.506V9.247h1.583C5.516,9.494,5.482,9.743,5.482,10c0,2.497,2.023,4.52,4.518,4.52c2.494,0,4.52-2.022,4.52-4.52c0-0.257-0.035-0.506-0.076-0.753h1.582V14.52z"></path>
                  </svg>
                </a>
              </div>
              <div class="lg:ml-6">
                <router-link :to="{name: 'contact'}" class="px-3 py-1 rounded-lg bg-teal-400 text-teal-100 hover:text-white hover:shadow shadow-inner">Contact</router-link>
              </div>
            </div>
          </div>
          <button @click="open = !open" class="px-2 py-1 text-teal-100 bg-teal-400 rounded-full lg:hidden flex justify-center items-center shadow hover:shadow-lg">
            <span v-if="open"><Close /></span>
            <span v-if="! open"><Chevron /></span>
          </button>
        </div>

        <div v-if="open" class="lg:hidden">
          <router-link @click.native="close" active-class="bg-gray-100" class="block rounded-lg hover:bg-teal-100 px-6 py-2" :to="{name: 'illustrations'}">Illustration jeunesse</router-link>
          <router-link @click.native="close" active-class="bg-gray-100" class="block rounded-lg hover:bg-teal-100 px-6 py-2" :to="{name: 'strips'}">BD</router-link>
          <router-link @click.native="close" active-class="bg-gray-100" class="block rounded-lg hover:bg-teal-100 px-6 py-2" :to="{name: 'originals'}">Oeuvres originales</router-link>
          <router-link @click.native="close" active-class="bg-gray-100" class="block rounded-lg hover:bg-teal-100 px-6 py-2" :to="{name: 'about'}">Qui suis-je ?</router-link>
          <router-link @click.native="close" active-class="bg-gray-100" class="block rounded-lg hover:bg-teal-100 px-6 py-2" :to="{name: 'contact'}">Contact</router-link>
          <a @click="close" class="mr-1 block rounded-lg hover:bg-teal-100 px-6 py-2"
            href="https://poulpychou.sumup.link"
            target="_blank"
            title="Etsy - Poulpy Chou">
            Boutique
          </a>

          <a @click="close" class="block rounded-lg hover:bg-teal-100 px-6 py-2" href="https://www.facebook.com/poulpesqueries/" target="_blank" title="Facebook - Poulpy Chou">Facebook</a>
          <a @click="close" class="block rounded-lg hover:bg-teal-100 px-6 py-2" href="http://poulpychou.tumblr.com" target="_blank"  title="Tumblr - Poulpy Chou">Tumblr</a>
          <a @click="close" class="block rounded-lg hover:bg-teal-100 px-6 py-2 mb-6" href="http://www.instagram.com/poulpychou/" target="_blank" title="Instagram - Poulpy Chou">Instagram</a>
        </div>
      </div>
    </header>
    <div class="md:mt-16"></div>
  </div>
</template>

<script>
import Close from '@/components/Close'
import Chevron from '@/components/Chevron'

export default {
  components: {
    Close,
    Chevron,
  },

  data() {
    return {
      open: false,
    };
  },

  methods: {
    close() {
      this.open = false;
    },
  },
}
</script>
